export default class State {
    id?: number;
    name: string;
    abbreviation: string;
}



// WEBPACK FOOTER //
// ./src/models/State.ts